import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"margin-left":"auto","margin-right":"auto","padding":"8px","width":"100%","display":"block","overflow":"auto"},
  class: "bracket"
}

import { onMounted, ref } from 'vue';
import Bracket from '../components/Bracket.vue';
import { bracketService } from '../services/bracket.service';
import _ from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'BracketHistoryView',
  setup(__props) {

let brackets = ref([{ name: 'foo', id: 0 }]);
let selectedBracket = ref(null);
let selectedBracketId = ref('');

onMounted(async () => {
    brackets.value = await bracketService.getAllBrackets();
    selectedBracketId.value = brackets.value[brackets.value.length - 1]?.id || '';
    changeSelectedBracket(selectedBracketId.value);
});

function changeSelectedBracket($event: any) {
    selectedBracket.value = _.find(brackets.value, (b) => b.id === $event);
    console.log(selectedBracket.value);
}


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_select, {
            "onUpdate:modelValue": [
              changeSelectedBracket,
              _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedBracketId) ? (selectedBracketId).value = $event : selectedBracketId = $event))
            ],
            modelValue: _unref(selectedBracketId),
            label: "Select Bracket",
            items: _unref(brackets),
            "item-title": "name",
            "item-value": "id"
          }, null, 8, ["modelValue", "items"])
        ]),
        _: 1
      })
    ]),
    (_unref(selectedBracket))
      ? (_openBlock(), _createBlock(Bracket, {
          key: 0,
          bracket: _unref(selectedBracket)?.bracket
        }, {
          game: _withCtx(({ game }) => [
            _createTextVNode(_toDisplayString(game), 1)
          ]),
          _: 1
        }, 8, ["bracket"]))
      : _createCommentVNode("", true)
  ]))
}
}

})